export const malta = {
  slug: "malta",
  name: "Malta",
  flag: "🇲🇹",
  tagline: "Affordable European Study Destination",
  heroImg: "https://images.unsplash.com/photo-1533106418989-88406c7cc8ca?q=80&w=1600&auto=format&fit=crop",
  accentColor: "#C62828",
  students: "15+",
  avgTuition: "€5,000–€12,000/yr",
  avgLiving: "€600–€1,000/mo",
  workPermit: "1 year post-study",
  ieltsReq: "6.0",
  intakeMonths: ["October", "February"],
  overview:
    "Malta offers English-speaking education, lower costs, Mediterranean lifestyle, and access to Europe.",
  whyChoose: [
    { icon: "🎓", title: "English Speaking", desc: "English is an official language." },
    { icon: "💰", title: "Affordable Costs", desc: "Lower tuition and living than many EU nations." },
    { icon: "🌍", title: "EU Member", desc: "Recognised degrees and European mobility." },
    { icon: "📋", title: "Work Options", desc: "Post-study and part-time work opportunities." },
    { icon: "☀️", title: "Lifestyle", desc: "Sunny climate and student-friendly environment." },
    { icon: "🤝", title: "Growing Demand", desc: "Hospitality, gaming, and finance sectors hiring." },
  ],
  process: [
    { step: "01", title: "Choose Course", desc: "Select programme and institution." },
    { step: "02", title: "Apply", desc: "Submit academic documents and SOP." },
    { step: "03", title: "Visa", desc: "Apply for student residence visa." },
    { step: "04", title: "Fly & Settle", desc: "Complete registration after arrival." },
  ],
  universities: [
    "university-malta","mcast","global-college-malta","american-university-malta"
  ],
  stats: [
    { n: "15+", label: "Students Placed" },
    { n: "€5k", label: "Min Tuition/yr" },
    { n: "90%", label: "Visa Success" },
    { n: "1yr", label: "Post-Study Permit" },
  ],
};